// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/theme.css';
// استيراد جميع المكونات من مجلد 'pages' بأسماء الملفات الجديدة
import HomePage from './pages/HomePage'; // كان Home
import Login from './pages/Login';
import Signup from './pages/Signup'; // تم تصحيح حالة الأحرف هنا
import ForgetPassword from './pages/ForgetPassword';
import CreatePassword from './pages/CreatePassword'; // كان ResetPassword
import ChangePassword from './pages/ChangePassword'; // لم يتغير اسمه
import WrongPage from './pages/WrongPage'; // كان ErrorPage
import RegisterPatient from './pages/RegisterPatient'; // كان MedicalRecord
import SearchPatient from './pages/SearchPatient'; // كان SearchPage
import Contact from './pages/Contact'; 
import About from './pages/About'; 
import ShowPatient from './pages/ShowPatient'; 
import DiagnosisModel from './pages/DiagnosisModel'; 
import ClassificationModel from './pages/ClassificationModel';
import SegmentationModel from './pages/SegmentationModel';
import AppointmentManagement from './pages/AppointmentManagement'; 
import PatientPortal from './pages/PatientPortal';
import Dashboard from './pages/Dashboard';
import BillingSystem from './pages/BillingSystem';
import Telemedicine from './pages/Telemedicine';
import PrescriptionManagement from './pages/PrescriptionManagement';
import InventoryManagement from './pages/InventoryManagement';
function App() {
  return (
    <Router>
      <Routes>
        {/* مسارات التطبيق */}
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} /> {/* مسار Signup */}
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/create-password" element={<CreatePassword />} /> {/* مسار CreatePassword */}
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/register-patient" element={<RegisterPatient />} /> {/* مسار RegisterPatient */}
        <Route path="/search-patient" element={<SearchPatient />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/show-patient" element={<ShowPatient />} /> 
        <Route path="*" element={<WrongPage />} />
        <Route path="/diagnosis-model" element={<DiagnosisModel />} />
        <Route path="/classification-model" element={<ClassificationModel />} />
        <Route path="/segmentation-model" element={<SegmentationModel />} />  
        <Route path="/appointments" element={<AppointmentManagement />} />
        <Route path="/patient-portal" element={<PatientPortal />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/billing" element={<BillingSystem />} />
        <Route path="/telemedicine" element={<Telemedicine />} />
        <Route path="/prescriptions" element={<PrescriptionManagement />} />
        <Route path="/inventory" element={<InventoryManagement />} /> 
      </Routes>
    </Router>
  );
}

export default App;
